import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/LeftSidebar.css";

const LeftSidebar = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleSidebar = () => {
        setIsExpanded((prev) => !prev);
    };

    return (
        <aside className={`left-sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
            <div className="toggle-section">
                <button className="toggle-btn" onClick={toggleSidebar}>
                    {isExpanded ? <i className="closeIconHB"></i> : <i className="menuIconHB"></i>}
                </button>
            </div>

            <nav className="sidebar-nav">
                <ul>
                    <li>
                        <NavLink to="/" className={({ isActive }) => isActive ? "navlink active" : "navlink"}>
                            {({ isActive }) => (
                                <>
                                    <i className={isActive ? "homeIconActive" : "homeIcon"}></i>
                                    {isExpanded && "Home"}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/insight-hub" className={({ isActive }) => isActive ? "navlink active" : "navlink"}>
                            {({ isActive }) => (
                                <>
                                    <i className={isActive ? "kbMenuActive" : "kbMenu"}></i>
                                    {isExpanded && "Insight Hub"}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/lineage-studio" className={({ isActive }) => isActive ? "navlink active" : "navlink"}>
                            {({ isActive }) => (
                                <>
                                    <i className={isActive ? "clMenuActive" : "clMenu"}></i>
                                    {isExpanded && "Lineage Studio"}
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/advanced-lineage-studio" className={({ isActive }) => isActive ? "navlink active" : "navlink"}>
                            {({ isActive }) => (
                                <>
                                    <i className={isActive ? "aclMenuActive" : "aclMenu"}></i>
                                    {isExpanded && "Advanced Lineage Studio"}
                                </>
                            )}
                        </NavLink>
                    </li>
                </ul>
            </nav>

        </aside>
    );
};

export default LeftSidebar;
